import React from 'react';
import { Link } from 'react-router-dom';
import { Zap } from 'lucide-react';

export const LegalLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-white">
    <header className="h-16 border-b border-slate-200 bg-white">
      <div className="max-w-3xl mx-auto h-full px-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <Zap className="w-6 h-6 text-orange-500" />
          <span className="font-black text-lg tracking-tight" style={{ fontFamily: 'Barlow Condensed' }}>BIDSENTRY</span>
        </Link>
        <nav className="flex items-center gap-6 text-sm text-slate-500">
          <Link to="/terms" className="hover:text-slate-900 transition-colors">Terms</Link>
          <Link to="/privacy" className="hover:text-slate-900 transition-colors">Privacy</Link>
          <Link to="/cookies" className="hover:text-slate-900 transition-colors">Cookies</Link>
        </nav>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-black mb-2 text-slate-900" style={{ fontFamily: 'Barlow Condensed' }}>
        {title}
      </h1>
      {lastUpdated && (
        <p className="text-sm text-slate-500 mb-8">Last Updated: {lastUpdated}</p>
      )}
      <div className="prose prose-slate prose-sm max-w-none">
        {children}
      </div>
    </main>

    <footer className="border-t border-slate-200 py-6 bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 text-center space-y-2">
        <div className="flex items-center justify-center gap-4 text-sm text-slate-500">
          <Link to="/terms" className="hover:text-slate-900 transition-colors">Terms</Link>
          <span className="text-slate-300">|</span>
          <Link to="/privacy" className="hover:text-slate-900 transition-colors">Privacy</Link>
          <span className="text-slate-300">|</span>
          <Link to="/cookies" className="hover:text-slate-900 transition-colors">Cookies</Link>
        </div>
        <p className="text-[11px] text-slate-400 leading-relaxed">
          Bidsentry Ltd &bull; Registered in England and Wales &bull; Company No: 17096278 &bull; Registered Office: 124 City Road, London, EC1V 2NX, United Kingdom
        </p>
      </div>
    </footer>
  </div>
);
